/**
 * Noop: A function which performs no operation. Useful for empty callbacks and
 * @returns undefined
 */
export function noop(..._args: unknown[]) {
  return undefined;
}
